var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view__404"},[_c('div',{staticClass:"view__404__inner"},[_c('ErrorBox',{attrs:{"title":"Beklager, men denne siden finnes ikke."}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }